// Modal.js
import React from "react";
import styled from "styled-components";

const Styles2 = styled.div`

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6); /* dark background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1200;
}

.modal-content {
    background-color: #fff;
    padding: 24px;
    border-radius: 20px;
    width: 50vw;
    height: 560px;
    max-width: 90%;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}


    /* - - - - - - - - - - - - - - - - - - - - - Responsive Styles - - - - - - - - - - - - - - - - - - - - - */


/* Extra Small Mobile (320px - 575px) */
@media (max-width: 575px) {

  .modal-content {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      width: 92.5vw;
      height: 560px;
      max-width: 90%;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  }
 
}

/* Small Mobile/Mobile Landscape (576px - 767px) */
@media (min-width: 576px) and (max-width: 767px) {

  .modal-content {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      width: 88.5vw;
      height: 560px;
      max-width: 90%;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  }

}

/* Multiple conditions with AND */
@media (min-width: 768px) and (max-width: 991px) { 

  .modal-content {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      width: 82.5vw;
      height: 560px;
      max-width: 90%;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  }


}

@media (min-width: 992px) and (max-width: 1199px) {

  .modal-content {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      width: 72.5vw;
      height: 560px;
      max-width: 90%;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  }

}

/* 💻 Desktop (1200px - 1399px) */
@media (min-width: 1200px) and (max-width: 1399px) {

  .modal-content {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      width: 60vw;
      height: 560px;
      max-width: 90%;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  }


}


/* 🖥️ Large Desktop (1400px+)  */
@media (min-width: 1400px) {

}



`

class Modal extends React.Component {
  render() {
    if (!this.props.isOpen) return null;

    return (
      <Styles2>
        <div className="modal-overlay" onClick={this.props.onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {this.props.children}
          </div>
        </div>
      </Styles2>
    );
  }
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)", // dark background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modal: {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "20px",
    width: "50vw",
    height: '560px',
    maxWidth: "90%",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
  }
};

export default Modal;